import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import LandingPage from "./landingpage/landingpage";
import App from "./App";
import MainPage from "./Main pages/homepage";
import FolderView from "./Main pages/FolderView.js";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MyCloudPage from "./Main pages/Mycloudpage.js";
import ChannelPage from "./Main pages/Channelpage.js";
import HomePageContent from "./Main pages/HomePageContent.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
     <Route path="/" element={<LandingPage />} />
    <Route path="/app" element={<App />} />

    {/* 🔥 MAIN DASHBOARD ROUTING */}
    <Route path="/main" element={<MainPage />}>

      <Route index element={<HomePageContent />} /> 
      <Route path="home" element={<HomePageContent />} />
      <Route path="mycloud" element={<MyCloudPage />} />
      <Route path="channels" element={<ChannelPage />} />
      <Route path="settings" element={<h1>Settings</h1>} />

      {/* 🔥 FOLDER VIEW INSIDE MAIN LAYOUT */}
      <Route path="folder/:folderId" element={<FolderView />} />

    </Route>

    </Routes>
  </BrowserRouter>
);